/* js-cart-notification FIXED */

var CartNotification = {
  init: function () {
    if (CartNotification._initialized) return;
    CartNotification._initialized = true;

    const root = window.Shopify?.routes?.root || '/';
    const isCartPage = $('body').hasClass('cart');

    /* -------------------------
       OPEN / CLOSE CART
    ------------------------- */

    $(document).on('click', '.open-cart', function (e) {
      e.preventDefault();
      history.pushState(null, null, ' ');
      openCart();
    });

    $(document).on('click', '.button-close-cart, .cart-notification__layer', closeCart);

    $(document).on('click', function (e) {
      if (!$(e.target).closest('.button-add-cart, .cart-notification, .open-cart').length) {
        closeCart();
      }
    });

    function openCart() {
      updateCartTotals();
      $('.cart-notification').addClass('cart-notification-active');
      $('body').addClass('cart-notification-open');
      $('.open-cart').attr('aria-expanded', 'true');
    }

    CartNotification.open = openCart;

    function closeCart() {
      if (isCartPage) return;

      $('.cart-notification').removeClass('cart-notification-active');
      $('body').removeClass('cart-notification-open');
      $('.open-cart').attr('aria-expanded', 'false');
    }

    /* -------------------------
       ADD TO CART
    ------------------------- */

    $(document).on('click', '.button-add-cart', function () {
      const $btn = $(this);

      // 🚨 IMPORTANT: bloqueig correcte
      if ($btn.hasClass('product-unavailable') || $btn.hasClass('product-adding') || $btn.prop('disabled')) {
        return;
      }

      const productID = Number($btn.attr('data-id'));
      const productParent = $btn.data('parent');
      const randomID = Math.floor(Math.random() * 1e9);

      let productQty = Math.max(
        1,
        parseInt($('#product_data input[name="quantity"]').val(), 10) || 1
      );

      // 🚨 Validació crítica
      if (!productID || isNaN(productID)) {
        console.error('❌ Variant ID invàlid:', $btn.attr('data-id'));
        return;
      }

      $btn.addClass('product-adding');
      $btn.prop('disabled', true);

      const items = [];

      /* --- ADDONS --- */
      $('#product_data [name="product_addon"]').each(function () {
        const $addon = $(this);

        const qty = parseInt($addon.find('[name="quantity"]').val(), 10) || 0;
        if (qty <= 0) return;

        const propName = $addon.find('[name="property"]').data('name');
        const propValue = $addon.find('[name="property"]').data('value');

        const properties = { _link: randomID };

        if (propName) properties[propName] = propValue;

        items.push({
          id: Number($addon.data('id')),
          quantity: qty,
          properties
        });
      });

      /* --- PROPERTIES PRODUCTE PRINCIPAL --- */
      const properties = { _parent: productParent };

      $('#product_data [name="product_property"]').each(function () {
        const propName = $(this).data('name');
        const propValue = $(this).data('value');

        if (propName) properties[propName] = propValue;
      });

      if (items.length) {
        properties._mlink = randomID;
      }

      /* --- PRODUCTE PRINCIPAL --- */
      items.push({
        id: productID,
        quantity: productQty,
        properties
      });

      addToCart(
        {
          items,
          sections: ['section-cart-notification']
        },
        $btn
      );
    });

    /* -------------------------
       AJAX ADD TO CART
    ------------------------- */

    function addToCart(payload, $btn) {
      const sectionId = getCartSectionId();
      const body = {
        items: payload.items || [],
        sections: [sectionId],
        sections_url: window.location.pathname
      };

      $.ajax({
        url: root + 'cart/add.js',
        method: 'POST',
        data: JSON.stringify(body),
        contentType: 'application/json; charset=utf-8',
        dataType: 'json'
      })
        .done(function (data) {
          updateCartNotificationHTML(data);
          openCart();
          refreshCartNotification();
        })
        .fail(function (xhr) {
          const msg =
            xhr?.responseJSON?.description ||
            xhr?.responseJSON?.message ||
            'Error afegint el producte.';

          alert(msg);

          console.error('ADD TO CART ERROR:', {
            status: xhr.status,
            response: xhr.responseJSON || xhr.responseText
          });
        })
        .always(function () {
          if ($btn) {
            $btn.removeClass('product-adding');
            $btn.prop('disabled', false);
          }
        });
    }

    CartNotification.addToCart = addToCart;

    function getCartSectionId() {
      return $('.cart-notification').data('section-id') || 'section-cart-notification';
    }

    function updateRecommendation() {
      const cartProductIds = new Set();

      $('.cart-notification__products__item').each(function () {
        const $item = $(this);

        if ($item.data('line') === 'removed') return;

        const productId = Number($item.data('product-id'));

        if (productId) cartProductIds.add(productId);
      });

      $('.cart-notification__recommendation-product').each(function () {
        const productId = Number($(this).data('product-id'));

        if (cartProductIds.has(productId)) {
          $(this).remove();
        }
      });

      $('.cart-notification__recommendation-products').each(function () {
        const slider = this;

        if (slider.swiper) {
          slider.swiper.destroy(true, true);
        }

        const recommendation = slider.closest('.cart-notification__recommendation');
        const pagination = recommendation?.querySelector('.cart-notification__recommendation-pagination');
        const scrollbar = slider.querySelector('.cart-notification__recommendation-scrollbar');

        if (!recommendation || !pagination || !scrollbar || !window.Swiper) return;

        new Swiper(slider, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          grabCursor: true,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          pagination: {
            el: pagination,
            clickable: true
          },
          scrollbar: {
            el: scrollbar,
            draggable: true,
            hide: false
          },
          a11y: {
            enabled: true
          }
        });
      });
    }

    CartNotification.refresh = function () {
      bindCartEvents();
      updateCartTotals();
      updateRecommendation();
    };

    $(document).on('click', '.cart-notification__recommendation-button', function () {
      const $btn = $(this);
      const variantId = Number($btn.data('id'));

      if (!variantId || $btn.hasClass('product-adding') || $btn.prop('disabled')) return;

      $btn.addClass('product-adding');
      $btn.prop('disabled', true);

      addToCart(
        {
          items: [{ id: variantId, quantity: 1 }],
          sections: ['section-cart-notification']
        },
        $btn
      );
    });

    /* -------------------------
       UPDATE CART HTML
    ------------------------- */

    function syncProductRoutine() {
      if (!window.ProductRoutine) return;

      document.querySelectorAll('[data-product-routine]').forEach((routine) => {
        window.ProductRoutine.sync(routine);
      });
    }

    function updateCartNotificationHTML(data) {
      const sectionId = getCartSectionId();
      const html = data?.sections?.[sectionId] || data?.sections?.['section-cart-notification'];

      if (!html) {
        console.warn('⚠️ No sections returned', data);
        openCart();
        updateCartTotals();
        syncProductRoutine();
        return;
      }

      const $response = $('<div>').html(html);
      const $updatedCart = $response.find('#CartNotification');

      if ($updatedCart.length) {
        $('.cart-notification__products').html($updatedCart.find('.cart-notification__products').html());
        $('.cart-notification__recommendation').replaceWith(
          $updatedCart.find('.cart-notification__recommendation')
        );
      } else {
        $('.cart-notification__products').html($response.html());
      }

      bindCartEvents();
      updateCartTotals();
      updateRecommendation();
      syncProductRoutine();
    }

    CartNotification.updateHTML = updateCartNotificationHTML;

    function refreshCartNotification() {
      const sectionId = getCartSectionId();

      return $.get(root, { sections: sectionId })
        .done(function (sections) {
          updateCartNotificationHTML({ sections });
        });
    }

    /* -------------------------
       REMOVE ITEM
    ------------------------- */

    function removeFromCart($item) {
      if ($item.data('line') === 'removed') return;

      const changes = [{ line: $item.data('line'), quantity: 0 }];
      $item.data('line', 'removed');

      const mlink = $item.data('mlink');

      if (mlink) {
        $('.cart-notification__products__item').each(function () {
          const $linked = $(this);

          if ($linked.data('link') == mlink && $linked.data('line') !== 'removed') {
            changes.push({
              line: $linked.data('line'),
              quantity: 0
            });

            $linked.data('line', 'removed');
          }
        });
      }

      const doChanges = (list) => {
        if (!list.length) {
          afterRemove();
          return;
        }

        $.post(root + 'cart/change.js', list[0], null, 'json')
          .always(() => doChanges(list.slice(1)));
      };

      doChanges(changes);
    }

    function afterRemove() {
      const $items = $('.cart-notification__products__item');
      const $removedItems = $items.filter(function () {
        return $(this).data('line') === 'removed';
      });
      const hasRemainingItems = $items.filter(function () {
        return $(this).data('line') !== 'removed';
      }).length > 0;

      $removedItems.fadeOut(200, function () {
        $(this).remove();
      });

      updateCartTotals();
      syncProductRoutine();

      refreshCartNotification();

      if (!hasRemainingItems) {
        closeCart();
      }
    }

    /* -------------------------
       EVENTS (ITEMS)
    ------------------------- */

    function bindCartEvents() {
      const $items = $('.cart-notification__products__item');

      /* REMOVE */
      $items.find('.btn-remove').off('click').on('click', function () {
        removeFromCart($(this).closest('.cart-notification__products__item'));
      });

      /* PLUS */
      $items.find('.plus').off('click').on('click', function () {
        const $input = $(this).siblings('input[type=number]');
        if ($input[0]) $input[0].stepUp();
        $input.trigger('change');
      });

      /* MINUS */
      $items.find('.minus').off('click').on('click', function () {
        const $input = $(this).siblings('input[type=number]');
        if ($input[0]) $input[0].stepDown();
        $input.trigger('change');
      });

      /* CHANGE QTY */
      $items
        .find('.cart-notification__products__item__quantity')
        .off('change')
        .on('change', function () {
          const $input = $(this);
          const $item = $input.closest('.cart-notification__products__item');

          const line = $item.data('line');
          const newQty = parseInt($input.val(), 10) || 0;

          $.post(root + 'cart/change.js', { line, quantity: newQty }, null, 'json')
            .fail(function () {
              alert('No hi ha prou estoc disponible.');
              $input.val($input.attr('data-qty'));
            })
            .done(refreshCartNotification)
            .always(updateCartTotals);
        });
    }

    /* -------------------------
       TOTALS
    ------------------------- */

    function updateCartTotals() {
      let totalQty = 0;
      let totalAmount = 0;

      $('.cart-notification__products__item').each(function () {
        const $item = $(this);

        if ($item.data('line') === 'removed') return;

        const qty =
          parseInt(
            $item.find('.cart-notification__products__item__quantity').val(),
            10
          ) || 1;

        const price =
          parseFloat($item.find('[data-price]').data('price')) || 0;

        totalQty += qty;
        totalAmount += qty * price;
      });

      $('.cart-notification__bottom .cart-notification__price').html(
        formatMoney(totalAmount)
      );

      $('.num-cart').html(totalQty);
      $('.cart-notification__count').html(totalQty);

      $('.cart-notification__shipping-progress').each(function () {
        const $progress = $(this);
        const threshold = parseInt($progress.data('threshold'), 10) || 0;
        const remaining = Math.max(0, threshold - totalAmount);
        const percentage = threshold > 0 ? Math.min(100, (totalAmount / threshold) * 100) : 100;
        const message = remaining > 0
          ? String($progress.data('remaining')).replace('[amount]', formatMoney(remaining))
          : String($progress.data('reached'));

        $progress.find('.cart-notification__shipping-progress-text').html(message);
        $progress.find('.cart-notification__shipping-progress-value').css('width', percentage + '%');
      });

      if (totalQty === 0) {
        $('.cart-empty').show();
        $('.cart-notification--topwrapper').hide();
      } else {
        $('.cart-empty').hide();
        $('.cart-notification--topwrapper').show();
      }
    }

    /* INIT */
    updateCartTotals();
    bindCartEvents();
    updateRecommendation();

    $(document)
      .off('shopify:section:load.cartNotification')
      .on('shopify:section:load.cartNotification', function (event) {
        if ($(event.target).find('.cart-notification').length) {
          CartNotification.refresh();
        }
      });

    if (isCartPage) {
      openCart();
    }
  }
};

CartNotification.init();
